"use client";

import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export function SectionHeader({
  eyebrow,
  title,
  description,
  align = "left",
  className,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  className?: string;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={cn(
        "max-w-3xl",
        align === "center" && "mx-auto text-center",
        className,
      )}
    >
      {eyebrow ? <p className="eyebrow mb-5">{eyebrow}</p> : null}
      <h2 className="display-title text-[clamp(1.85rem,7.5vw,3.75rem)] sm:text-5xl md:text-6xl whitespace-pre-line">{title}</h2>
      {description ? (
        <p className={cn("mt-4 text-sm sm:mt-5 sm:text-base md:text-lg text-muted leading-relaxed", align === "center" && "mx-auto")}>
          {description}
        </p>
      ) : null}
    </motion.div>
  );
}